module.exports = __webpack_public_path__ + "img/logo-full.518023f3.png";